import React from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import Checkbox from '@appComponents/Checkbox/Checkbox';
import { EAgreementType } from '../../InvestmentAgreementApp';

import * as style from './AgreementTemplateStyles.module.scss'
import * as elements from '@appStyles/_elements.module.scss';

type Props = {
  agreement: BrokerAgreement;
  closeModal: () => void;
  onSubmit: (id: string) => void;
};

export type BrokerAgreement = {
  title: string;
  description: string;
  options: string[];
  id: string;
  type?: EAgreementType;
};

const validationSchema = () =>
  Yup.object({
    agreement_0: Yup.boolean().test(
      'agreement-check',
      'All required.',
      (_, context) => Object.values(context.parent).every(agreement => agreement)
    ),
  });

export const AgreementTemplate = ({ agreement, closeModal, onSubmit }: Props) => {

  const initialValues = agreement?.options.reduce((result, _, index) => {
    return {
      ...result,
      [`agreement_${index}`]: false,
    };
  }, { agreement_0: false });

  const formik = useFormik<{ [index: string]: boolean }>({
    initialValues,
    onSubmit: (values) => {
      closeModal();
      onSubmit(agreement.id);
    },
    validationSchema: validationSchema(),
    validateOnMount: true,
  });

  if (!agreement) return null;

  const { options, title, description } = agreement;

  return (
    <form className={style.root} onSubmit={formik.handleSubmit} >
      <p className={style.title}>{title}</p>
      <p className={style.description}>{description}</p>
      {options.map((option, index) => (
        <div className={style.agreement} key={option}>
          <Checkbox
            className={style.checkbox}
            {...formik.getFieldProps(`agreement_${index}`)}
            onChange={(e) => {
              formik.setFieldValue(`agreement_${index}`, e.currentTarget.checked);
            }}
            checked={formik.values[`agreement_${index}`]}
          />
          <p className={style.agreementOption}>{option}</p>
        </div>
      ))}
      <div
        className={style.actionWrapper}
      >
        <button
          type="button"
          className={`${elements.btn} ${style.cancelBtn}`}
          onClick={closeModal}
        >
          Cancel
        </button>
        <button
          type="submit"
          className={`${elements.btn} ${elements.btnSuccess} `}
          disabled={!formik.isValid}
        >
          Sign
        </button>
      </div>

    </form>
  );
};
